module.exports = __webpack_public_path__ + "static/media/5_r_two_monitor_89.58_53.98.d4218019.png";